<investment-advisor-activities [service]="service"></investment-advisor-activities>
